<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_xii"></a><a id="page_xiii">Preface to the Second Edition</a></h1><a id="page_xiii">
<p class="para">Since 1987, research on the fourth century has continued to flourish. The present work has attracted its fair share of discussion in the past fourteen years; and, while there are many pages that would now need to be written otherwise and a good many areas in which I might want to approach a subject differently, it would be a very large task to revise the entire book. The generous suggestion from Alex Wright at SCM Press that a new edition might be possible has allowed me the opportunity to respond to various criticisms and to acknowledge weaknesses, as well as in some cases to offer further argument for what I still believe to be defensible positions. The appendix to the book, ‘Arius since 1987’ attempts to give a sketchy survey of some new moves in research as well as to engage with some commentators and critics. My hope is that this additional material will stimulate further debate and clarification. I am deeply grateful to all my colleagues who have taken the trouble to discuss the original work, to readers and students who still wish to tackle its subject matter, and to SCM Press for giving it a new lease of life. Whatever the very limited merits of the book, it should be clear that the questions both of substance and of method dealt with here are no less absorbing and significant now than when the work first appeared.</p>
<p class="right"><span class="smallcaps">ROWAN WILLIAMS</span></p>
</a><p class="para1"><a id="page_xiii"><em>Newport, Passiontide 2001</em> </a><a id="page_xiv"></a></p><a id="page_xiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Preface02.vue?67cdc450